import React from 'react';
import cameraIcon from '../../../img/camera.svg';
import wrenchIcon from '../../../img/wrench.svg';
import galleryIcon from '../../../img/galeria.svg';
import checkIcon from '../../../img/check-mark.svg';
import type { ChecklistType, ChecklistTab } from '../../../types/checklist';
import { checklistTabLabel, isServiceVisible } from '../../../types/checklist';

type TabMeta = {
  category: ChecklistTab;
  icon: string;
};

const tabMeta: Record<ChecklistTab, TabMeta> = {
  ANGLES: { category: 'ANGLES', icon: cameraIcon },
  SERVICE: { category: 'SERVICE', icon: wrenchIcon },
  ITEMS: { category: 'ITEMS', icon: galleryIcon },
};

export type ChecklistTabsStatus = Record<ChecklistTab, { required: boolean; ok: boolean; count: number; countLabel?: string }>;

interface ChecklistTabsProps {
  checklistType: ChecklistType;
  active: ChecklistTab;
  onChange: (next: ChecklistTab) => void;
  status: ChecklistTabsStatus;
  /** Exibe a aba "Imagens de saída" mesmo fora da SAÍDA (ex: visualização unificada). */
  showService?: boolean;
}

const ChecklistTabs: React.FC<ChecklistTabsProps> = ({ checklistType, active, onChange, status, showService }) => {
  const visibleTabs: ChecklistTab[] = ['ANGLES', 'ITEMS'];
  if (isServiceVisible(checklistType) || showService) visibleTabs.push('SERVICE');

  return (
    <div className="checklist-tabs">
      {visibleTabs.map((category) => {
        const meta = tabMeta[category];
        const st = status[category];
        const showCheck = st.required ? st.ok : st.count > 0;

        return (
          <button
            key={category}
            type="button"
            className={active === category ? 'checklist-tab active' : 'checklist-tab'}
            onClick={() => onChange(category)}
          >
            <span className="checklist-tab-left">
              <img className="checklist-tab-icon" src={meta.icon} alt="" aria-hidden="true" />
              <span className="checklist-tab-label">{checklistTabLabel[category]}</span>
              {st.required && <span className="checklist-tab-required">Obrigatório</span>}
            </span>
            <span className="checklist-tab-right">
              <span className="checklist-tab-count">{st.countLabel ?? st.count}</span>
              {showCheck && <img className="checklist-tab-check" src={checkIcon} alt="" aria-hidden="true" />}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default ChecklistTabs;
